import React from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import $ from "jquery";
import { createHistory } from "history";
import { objectToQueryString } from "../../Common/Utils";

export default class HistoryWidget extends React.Component {
    constructor(props) {
        super(props);

        this.url = this.props.url;

        this.history = createHistory();
        this.unlisten = this.history.listen((location) => {
            if (location.pathname === this.url && location.action === "POP") {
                $.ajax({
                    url: this.url,
                    method: "GET",
                    data: decodeURIComponent(location.search.substring(1)),
                    dataType: "json",
                    success: (result) => {
                        this.store.load({
                            products: result.products,
                            matrix: result.matrix,
                        });
                    },
                });
            }
        });

        this.store = ComponentRegistry.getStore("ProductCompareStore");

        this.onStoreChange = this.onStoreChange.bind(this);
        this.store.listen(this.onStoreChange);
    }

    onStoreChange(storeState) {
        this.history.push({
            pathname: this.url,
            search: (this.url.indexOf("?") > -1 ? "&" : "?") + objectToQueryString({
                products: storeState.products.map(value => value.sku),
            }),
        })
    }

    render() {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductCompare/Widgets/HistoryWidget.jsx